<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 v-t="'entities.manufacturer.name_plural'" class="mt-0"></h1>
      <el-switch
        v-model="editModeToggle"
        :active-text="editModeToggleActiveText"
      />
    </div>

    <dx-data-grid
      ref="dataGrid"
      :columns="columns"
      :data-source="store"
      :remote-operations="remoteOperations"
      :show-borders="true"
      :show-row-lines="false"
      :show-column-lines="true"
      :row-alternation-enabled="true"
    >
      <dx-editing
        :allow-adding="true"
        :allow-updating="true"
        :allow-deleting="true"
        :mode="editMode"
      />

      <dx-paging :page-size="15"/>
      <dx-pager
        :allowed-page-sizes="[15, 30, 50]"
        :visible="true"
        :show-info="true"
        :show-navigation-buttons="true"
        :show-page-size-selector="true"
      />
    </dx-data-grid>
  </div>
</template>

<script>
import { DxDataGrid } from 'devextreme-vue';
import { DxEditing, DxPager, DxPaging } from 'devextreme-vue/data-grid';
import { omit } from 'lodash';
import { mapState } from 'vuex';
import createBackendStore from '@/lib/create-backend-store';
import { buildColumns } from '@/lib/data-grid-columns';

export default {
  name: 'Manufacturers',
  components: {
    DxDataGrid,
    DxEditing,
    DxPager,
    DxPaging,
  },
  data() {
    return {
      columns: [],
      store: null,
      remoteOperations: {
        paging: true,
        filtering: true,
        sorting: true,
      },
      editModeToggle: false,
    };
  },
  computed: {
    ...mapState(['statuses']),
    editMode() {
      return this.editModeToggle ? 'batch' : 'row';
    },
    editModeToggleActiveText() {
      return this.$t('common.batchMode');
    },
  },
  methods: {
    buildColumns,
    configureColumns() {
      return this.buildColumns('manufacturer', [
        {
          property: 'name',
          sortOrder: 'asc',
        },
        ...this.statuses
          .map(status => ({
            property: 'statusMap[:id]',
            captionContext: 'short',
            options: { status },
            allowFiltering: false,
            allowSorting: false,
            width: 75,
          })),
      ]);
    },
    configureStore(columns) {
      const fields = columns
        .map(c => c.dataField)
        .filter(f => f && !f.startsWith('statusMap'));

      fields.push('statuses.id');

      return createBackendStore('/manufacturers', {
        fields,
        toRow: (manufacturer) => {
          const manufacturerStatusIds = manufacturer.statuses.map(status => status.id);
          const statusMap = {};

          this.statuses.forEach((status) => {
            statusMap[status.id] = manufacturerStatusIds.includes(status.id);
          });

          // eslint-disable-next-line no-param-reassign
          manufacturer.statusMap = statusMap;

          return manufacturer;
        },
        valuesFilter: values => omit(values, ['statusMap']),
        afterInsertOrUpdate: async (key, values) => {
          if (!values.statusMap) return;

          const promises = Object.entries(values.statusMap)
            .map(async ([statusIdString, value]) => {
              const statusId = parseInt(statusIdString, 10);

              if (value) {
                await this.$http.post(`/manufacturers/${key}/statuses`, { id: statusId });
              } else {
                await this.$http.delete(`/manufacturers/${key}/statuses/${statusId}`);
              }
            });

          await Promise.all(promises);
        },
      });
    },
  },
  created() {
    this.columns = this.configureColumns();
    this.store = this.configureStore(this.columns);
  },
};
</script>

<style scoped>

</style>
